document.addEventListener("DOMContentLoaded", function () {
  const swiperWrapper = document.querySelector(
    ".logoList_Slider .swiper-wrapper"
  );
  // const slide = swiperWrapper.querySelector(".swiper-slide");

  // if (slide) {
  //   for (let i = 0; i < 3; i++) {
  //     let clone = slide.cloneNode(true);
  //     swiperWrapper.appendChild(clone);
  //   }
  // }

  var swiper = new Swiper(".logoList_Slider", {
    slidesPerView: "auto",
    spaceBetween: 60,
    loop: true,
    autoplay: {
      delay: 0,
      disableOnInteraction: false,
    },
    speed: 4000,
    breakpoints: {
      300: {
        spaceBetween: 20,
      },
      576: {
        spaceBetween: 30,
      },
      769: {
        spaceBetween: 40,
      },
      1024: {
        spaceBetween: 60,
      },
    },
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const swiperWrapper = document.querySelector(".testiSlider .swiper-wrapper");

  var swiper = new Swiper(".testiSlider", {
    slidesPerView: "auto",
    spaceBetween: 30,
    loop: true,
    centeredSlides: true,
    grabCursor: true,
    breakpoints: {
      300: {
        spaceBetween: 10,
      },
      576: {
        spaceBetween: 15,
      },
      769: {
        spaceBetween: 20,
      },
      1025: {
        spaceBetween: 30,
      },
    },
  });
});

// SCRIPT FOR ACCORDIANS FAQS

document.addEventListener("DOMContentLoaded", function () {
  function faqsAccordion() {
    var accordionSections = document.querySelectorAll(".faq__accordion");

    accordionSections.forEach((section) => {
      var accordionItemHeaders = section.querySelectorAll(
        ".accordion-item-header"
      );

      if (accordionItemHeaders.length > 0) {
        var firstAccordionItemHeader = accordionItemHeaders[0];
        var firstAccordionItemBody =
          firstAccordionItemHeader.nextElementSibling;

        firstAccordionItemHeader.classList.add("active");
        firstAccordionItemBody.style.maxHeight =
          firstAccordionItemBody.scrollHeight + "px";
      }

      accordionItemHeaders.forEach((accordionItemHeader) => {
        accordionItemHeader.addEventListener("click", (event) => {
          var accordionItemBody = accordionItemHeader.nextElementSibling;

          accordionItemHeaders.forEach((item) => {
            if (item !== accordionItemHeader) {
              item.classList.remove("active");
              item.nextElementSibling.style.maxHeight = 0;
            }
          });

          accordionItemHeader.classList.toggle("active");

          if (accordionItemHeader.classList.contains("active")) {
            accordionItemBody.style.maxHeight =
              accordionItemBody.scrollHeight + "px";
          } else {
            accordionItemBody.style.maxHeight = 0;
          }
        });
      });
    });
  }

  faqsAccordion();
});

// SCRIPT FOR ACCORDIANS FAQS
